import { render } from "./sign-out-icon.vue.js?vue&type=template&id=75953707!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./sign-out-icon.vue?vue&type=template&id=75953707"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__